/* eslint-disable react-hooks/exhaustive-deps */
import PackageItem from '../../EditPackage/SelectServices/PackageItem';
import {
  CheckboxActive,
  CheckboxDefault,
  CloseCircle,
  RadioActiveIcon,
  RadioInactiveIcon,
  SearchIcon,
} from '@/assets/svg';
import useDebounce from '@/helpers/useDebounce';
import {
  formatData,
  formatDataMeasurements,
} from '@/module/all-screenings/utils';
import checkinPatientDispatcher from '@/module/checkin-patient-information/action';
import {
  formatTotalPrice,
  generateKeyCompare,
} from '@/module/checkin-patient-information/util';
import { packageDispatcher } from '@/module/package-management';
import { StyledAccordion } from '@/new-components/CustomCollapseCard/styled';
import CustomTooltip from '@/new-components/CustomTooltip';
import { Typography } from '@material-ui/core';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import { cloneDeep, findIndex, isEmpty } from 'lodash';
import React, { useState, useEffect } from 'react';

const CustomCard = withStyles((theme) => ({
  root: {
    marginTop: 8,
    marginBottom: 8,
    padding: '8px 16px',
    boxShadow: 'none',
    borderRadius: 12,
    backgroundColor: (props) => (props.color ? props.color : '#F6F6F6'),
    width: (props) => (props.width ? props.width : 'unset'),
    border: `1px solid #F6F6F6`,

    '&.checked': {
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
}))(Card);

const CustomBox = withStyles({
  root: {
    borderBottom: '1px solid #F1F1F1',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
})(Box);

const CustomSearchInput = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },

    '& input': {
      minWidth: 335,
      minHeight: 48,
      padding: 0,
    },
  },
}))(TextField);

const useStyle = makeStyles({
  loadingWrapper: {
    display: 'flex',
    width: '100%',
    height: 100,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const rowItemStyle = makeStyles({
  title: {
    marginBottom: 16,
    fontWeight: 600,
  },
  price: {
    color: '#333333',
    fontWeight: 600,
  },
  loadingWrapper: {
    display: 'flex',
    width: '100%',
    height: 400,
    justifyContent: 'center',
    alignItems: 'center',
  },
  smallCircle: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#c1c1c1',
    margin: '0 5px',
    display: 'inline-block',
    color: '#c1c1c1',
  },
});

const CustomCheckboxRowItem = ({
  id,
  data,
  title,
  onChangeDataSelected,
  isPackage,
  isProfile,
  projectId,
  setFormValue,
  formValue,
  packageDetail,
  setPackageDetail,
  currentPackage,
  setCurrentPackage,
  dataPackageExisted,
  restrictedTestIds,
  locationId,
}) => {
  const classes = rowItemStyle();
  const [expanded, setExpanded] = useState('');
  const [currentValue, setCurrentValue] = useState({});

  const [profiles, setProfiles] = useState([]);
  const [radiologies, setRadiologies] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [ignoredTestsLocal, setIgnoredTestsLocal] = useState([]);
  const [ignoredProfilesLocal, setIgnoredProfilesLocal] = useState([]);
  const [bypassRestrictedLocationIds, setBypassRestrictedLocationIds] =
    useState([]);

  const debounceGetDetail = useDebounce(currentValue);
  const [loading, setLoading] = useState(false);

  const handleChangePackage = (value) => (event, isExpanded) => {
    resetData();
    const newData = { ...value, isChecked: isExpanded };
    setExpanded(isExpanded ? value.id : false);
    if (isExpanded) setCurrentValue(newData);
    onChangeDataSelected(newData);

    if ((currentPackage && value?.id !== currentPackage?.id) || !isExpanded) {
      setCurrentPackage && setCurrentPackage({});
    }

    if (
      (dataPackageExisted && value?.id === dataPackageExisted?.id) ||
      !isExpanded
    ) {
      setCurrentPackage && setCurrentPackage(dataPackageExisted);
    }
  };

  const handleChangeNonOptionalPackage = (value) => (event) => {
    const newData = {
      ...value,
      isChecked: value.isChecked ? !value.isChecked : true,
    };
    if (!value.isChecked) setCurrentValue(newData);
    onChangeDataSelected(newData);
    if (
      (currentPackage && value?.id !== currentPackage?.id) ||
      value.isChecked
    ) {
      setCurrentPackage && setCurrentPackage({});
    }
  };

  const resetData = () => {
    setPackageDetail({
      name: '',
      packageType: '',
      lstTests: [],
      lstProfiles: [],
      lstMeasurements: [],
      lstProcedures: [],
      lstRadiologies: [],
      lstVaccinations: [],
      lstReviews: [],
    });
    setFormValue({
      ...formValue,
      lstPackages: [],
      ignoredTests: [],
      ignoredProfiles: [],
    });

    setProcedures([]);
    setRadiologies([]);
    setProfiles([]);
    setCurrentValue({});
    setBypassRestrictedLocationIds([]);
  };

  useEffect(() => {
    if (isEmpty(debounceGetDetail)) return;
    setLoading(true);
    let listProcedures = [];
    let listRadiologies = [];
    let newIgnoredTests = [];
    let newIgnProfiles = [];

    if (isPackage)
      packageDispatcher.getPackageById(debounceGetDetail.id, (result) => {
        result.lstTests.forEach((item) => {
          if (item.category === 'Procedures')
            listProcedures = item.items?.sort(
              (a, b) => b.isRequired - a.isRequired
            );
          if (item.category === 'Radiologies')
            listRadiologies = item.items.sort(
              (a, b) => b.isRequired - a.isRequired
            );
        });
        // // Filter test restricted by location
        // if (!isEmpty(restrictedTestIds)) {
        //   listProcedures = listProcedures?.filter(
        //     it => !restrictedTestIds?.includes(it.id)
        //   );
        //   listRadiologies = listRadiologies?.filter(
        //     it => !restrictedTestIds?.includes(it.id)
        //   );
        // }

        const ignoredProcedures = [...listProcedures].filter(
          (it) => !it.isRequired
        );
        const newIgnoredProcedures = formatIgnoredTests(
          debounceGetDetail.id,
          ignoredProcedures,
          debounceGetDetail.projectId
        );
        const ignoredRadiologies = [...listRadiologies].filter(
          (it) => !it.isRequired
        );
        const newIgnoredRadiologies = formatIgnoredTests(
          debounceGetDetail.id,
          ignoredRadiologies,
          debounceGetDetail.projectId
        );

        const ignoredProfiles = [...result.lstProfiles].filter(
          (it) => !it.isRequired
        );
        const newIgnoredProfiles = formatIgnoredProfiles(
          debounceGetDetail.id,
          ignoredProfiles,
          debounceGetDetail.projectId
        );

        const ignoredTests = mergeArray(
          newIgnoredProcedures,
          newIgnoredRadiologies,
          'testId'
        );

        if (isEmpty(currentPackage?.ignoredTests)) {
          newIgnoredTests = ignoredTests;
        } else newIgnoredTests = currentPackage?.ignoredTests;

        if (isEmpty(currentPackage?.ignoredProfiles)) {
          newIgnProfiles = newIgnoredProfiles;
        } else {
          newIgnProfiles = currentPackage?.ignoredProfiles;
        }

        setIgnoredTestsLocal(newIgnoredTests);
        setIgnoredProfilesLocal(newIgnProfiles);
        setFormValue({
          ...formValue,
          lstPackages: [debounceGetDetail],
          ignoredTests: newIgnoredTests,
          ignoredProfiles: newIgnoredProfiles,
        });

        setProcedures(listProcedures);
        setRadiologies(listRadiologies);
        setProfiles(
          result.lstProfiles?.sort((a, b) => b.isRequired - a.isRequired)
        );

        const formatted = formatData(result);
        if (formatted) {
          const bypassIds = result?.bypassRestrictedLocationIds || [];
          const isBypassRestrictedLocation = bypassIds.includes(locationId);

          const totalMandatoryProcedure =
            isBypassRestrictedLocation &&
            typeof result?.totalMandatoryProcedure === 'number'
              ? result.totalMandatoryProcedure
              : formatted.totalMandatoryProcedure;

          const totalMandatoryRadiology =
            isBypassRestrictedLocation &&
            typeof result?.totalMandatoryRadiology === 'number'
              ? result.totalMandatoryRadiology
              : formatted.totalMandatoryRadiology;

          const totalMandatoryProfile =
            isBypassRestrictedLocation &&
            typeof result?.totalMandatoryProfile === 'number'
              ? result.totalMandatoryProfile
              : formatted.totalMandatoryProfile;

          setBypassRestrictedLocationIds(bypassIds);

          setPackageDetail({
            ...formatted,
            lstProcedures: listProcedures,
            lstRadiologies: listRadiologies,
            totalMandatoryProcedure,
            totalMandatoryRadiology,
            totalMandatoryProfile,
            name: result.name,
            price: debounceGetDetail?.price,
          });
        }

        setLoading(false);
      });
  }, [debounceGetDetail]);

  const formatIgnoredProfiles = (packageId, data, project = projectId) => {
    const newData = data.map((item) => ({
      profileId: item.id,
      packageId,
      projectId: project,
    }));
    return newData;
  };

  const formatIgnoredTests = (packageId, data, project = projectId) => {
    const newData = data.map((item) => ({
      testId: item.id,
      packageId,
      projectId: project,
    }));
    return newData;
  };
  const mergeArray = (a, b, key) => {
    const reduced = a.filter(
      (aitem) => !b.find((bitem) => aitem[key] === bitem[key])
    );
    return reduced.concat(b);
  };

  const onClickChangeService = (value) => (e) => {
    const newData = {
      ...value,
      isChecked: value.isChecked ? !value.isChecked : true,
    };
    onChangeDataSelected(newData);
  };

  return (
    <>
      <CustomBox key={id} pb={2.5} mb={2.5} width="100%" alignItems="center">
        <p className={classes.title}>
          <CustomTooltip content={title} />
        </p>
        {data.map((row) =>
          isPackage ? (
            row.hasOptional ? (
              <StyledAccordion
                key={row.id}
                expanded={expanded === row.id && row.isChecked}
                onChange={handleChangePackage(row)}
                className={clsx(
                  expanded === row.id && row.isChecked ? 'expanded' : ''
                )}
              >
                <AccordionSummary
                  aria-controls="panel-content"
                  id="panel-header"
                  expandIcon={<ExpandMore />}
                >
                  <Box display="flex" alignItems="center" gridGap={12}>
                    <Checkbox
                      icon={<RadioInactiveIcon />}
                      checkedIcon={<RadioActiveIcon />}
                      checked={row.isChecked}
                      color="primary"
                      style={{ padding: 0 }}
                    />
                    <CustomTooltip content={row.name} />
                  </Box>

                  <Typography className={classes.price}>
                    {formatTotalPrice(row?.price, '$')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {!isEmpty(packageDetail) &&
                    expanded === row.id &&
                    !loading && (
                      <PackageItem
                        projectId={debounceGetDetail?.projectId || projectId}
                        packageDetail={packageDetail}
                        profiles={profiles}
                        setProfiles={setProfiles}
                        procedures={procedures}
                        setProcedures={setProcedures}
                        radiologies={radiologies}
                        setRadiologies={setRadiologies}
                        formValue={formValue}
                        setFormValue={setFormValue}
                        ignoredProfilesLocal={ignoredProfilesLocal}
                        ignoredTestsLocal={ignoredTestsLocal}
                        currentPackage={currentPackage}
                        setCurrentPackage={setCurrentPackage}
                        dataPackageExisted={dataPackageExisted}
                        restrictedTestIds={restrictedTestIds}
                        locationId={locationId}
                        bypassRestrictedLocationIds={
                          bypassRestrictedLocationIds
                        }
                      />
                    )}
                </AccordionDetails>
              </StyledAccordion>
            ) : (
              <CustomCard
                key={row.id}
                className={clsx(row.isChecked ? 'checked' : '')}
                onClick={handleChangeNonOptionalPackage(row)}
                style={{ padding: '0 16px', height: 48 }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  py={1.5}
                >
                  <Box display="flex" alignItems="center" gridGap={12}>
                    <Checkbox
                      icon={<RadioInactiveIcon />}
                      checkedIcon={<RadioActiveIcon />}
                      checked={row.isChecked}
                      color="primary"
                      style={{ padding: 0 }}
                    />
                    <Box>
                      <CustomTooltip content={row.name} />
                    </Box>
                  </Box>

                  <Typography className={classes.price}>
                    {formatTotalPrice(row?.price, '$')}
                  </Typography>
                </Box>
              </CustomCard>
            )
          ) : (
            <CustomCard
              key={row.id}
              className={clsx(row.isChecked ? 'checked' : '')}
              onClick={onClickChangeService(row)}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                py={1.25}
              >
                <Box display="flex" alignItems="center" gridGap={12}>
                  <Checkbox
                    icon={<CheckboxDefault />}
                    checkedIcon={<CheckboxActive />}
                    checked={row.isChecked}
                    color="primary"
                    style={{ padding: 0 }}
                  />
                  <Box>
                    <CustomTooltip content={row.name} />
                    {isProfile && (
                      <Box display="flex" alignItems="center" color="#666666">
                        Test: {row.totalTests}
                        <div className={classes.smallCircle}></div>
                        Profile:{row.totalProfiles}
                      </Box>
                    )}
                  </Box>
                </Box>

                <Typography className={classes.price}>
                  {formatTotalPrice(row?.price, '$')}
                </Typography>
              </Box>
            </CustomCard>
          )
        )}
      </CustomBox>
    </>
  );
};

const ServicesItem = ({
  projectId,
  locationId,
  dataExist = [],
  category,
  isProfile,
  isPackage,
  restrictedPackageIds = [],
  restrictedTestIds = [],
  handleChangeData,
  filterKey,
  formValue,
  setFormValue,
  packageDetail,
  setPackageDetail,
  setCurrentPackage,
  currentPackage,
  dataPackageExisted,
  sessionBookedPrices = {},
  originalPrices = {},
  apptData = {},
  hasNavigatedBetweenSteps = false,
}) => {
  const classes = useStyle();
  const [searchKey, setSearchKey] = useState('');
  const [loadingSearch, setLoadingSearch] = useState('');
  const [data, setData] = useState([]);
  const debounceSearch = useDebounce(searchKey);
  const [localData, setLocalData] = useState([]);

  const generateNewTestExist = (testExistData) => {
    return testExistData.map((it) => ({
      ...it,
      keyCompare: generateKeyCompare(it.projectId, it.id || it.testId),
      isChecked: true,
    }));
  };

  const fetchData = (cb) => {
    setLoadingSearch(true);
    if (isProfile) {
      checkinPatientDispatcher.getTestProfiles(projectId, cb);
    } else if (isPackage) {
      checkinPatientDispatcher.getTestPackagesByLocation(
        { projectId, locationId },
        cb
      );
    } else {
      checkinPatientDispatcher.getAllListTests(
        { Category: category, projectId, locationId },
        cb
      );
    }
  };

  useEffect(() => {
    fetchData((values) => {
      let newData = [];
      const dataShowTable = {};
      const testExistWithKeyCompare = generateNewTestExist(dataExist);
      const restrictedServiceIds = [
        ...restrictedPackageIds,
        ...restrictedTestIds,
      ];

      values.forEach((project) => {
        const { id: projectId, items } = project;

        const testsFormat = formatDataMeasurements(
          items
            .filter((item) => !restrictedServiceIds.includes(item.id))
            .map((item) => ({
              ...item,
              testName: item.name || '',
              testCode: item.code || '',
              testPrice: item.price || 0,
              isVisible: item.isVisible !== false,
            }))
        );

        const newTests = testsFormat
          .map((it) => ({
            ...it,
            projectId,
            keyCompare: generateKeyCompare(projectId, it.id || it.testId),
            isChecked: false,
            isVisible: it.isVisible !== false,
          }))
          .sort((a, b) => a.price - b.price);

        newData.push({ ...project, items: newTests });
        dataShowTable[projectId] = false;
      });
      newData = updateCheckedData(newData, testExistWithKeyCompare);

      // Create a map of current prices from dataExist (formValue) to check if item was reselected with new price
      const currentPricesMap = {};
      if (dataExist && Array.isArray(dataExist)) {
        dataExist.forEach((item) => {
          const itemId = item.id || item.testId;
          if (itemId) {
            if (isPackage) {
              currentPricesMap[`package_${itemId}`] = item.price;
            } else if (isProfile) {
              currentPricesMap[`profile_${itemId}`] = item.price;
            } else {
              currentPricesMap[`test_${itemId}`] = item.price;
            }
          }
        });
      }

      // Override prices from sessionBookedPrices snapshot if item exists in snapshot
      // - If hasNavigatedBetweenSteps = false (chỉ switch tab): override for all items (checked and unselected) - follow EditPackage flow
      // - If hasNavigatedBetweenSteps = true (đã Back -> Next): only override for checked items, unselected show new price
      // Also don't override if item was reselected with new price (when hasNavigatedBetweenSteps = true)
      if (sessionBookedPrices && Object.keys(sessionBookedPrices).length > 0) {
        newData = newData.map((project) => {
          const newProject = cloneDeep(project);
          newProject.items = newProject.items.map((item) => {
            const newItem = { ...item };
            const itemId = item.id || item.testId;

            // If hasNavigatedBetweenSteps = false: process all items (checked and unselected)
            // If hasNavigatedBetweenSteps = true: only process checked items
            const shouldProcessItem =
              !hasNavigatedBetweenSteps || newItem.isChecked;

            if (shouldProcessItem) {
              let shouldOverride = true;

              // If hasNavigatedBetweenSteps = true (đã Back -> Next), check if item was reselected with new price
              // If item was reselected, don't override to preserve new price
              if (hasNavigatedBetweenSteps) {
                if (
                  isPackage &&
                  sessionBookedPrices.packages &&
                  sessionBookedPrices.packages[itemId] !== undefined
                ) {
                  const sessionPrice = sessionBookedPrices.packages[itemId];
                  const currentPrice = currentPricesMap[`package_${itemId}`];
                  if (
                    currentPrice !== undefined &&
                    currentPrice !== sessionPrice
                  ) {
                    shouldOverride = false;
                  }
                } else if (
                  isProfile &&
                  sessionBookedPrices.profiles &&
                  sessionBookedPrices.profiles[itemId] !== undefined
                ) {
                  const sessionPrice = sessionBookedPrices.profiles[itemId];
                  const currentPrice = currentPricesMap[`profile_${itemId}`];
                  if (
                    currentPrice !== undefined &&
                    currentPrice !== sessionPrice
                  ) {
                    shouldOverride = false;
                  }
                } else if (
                  !isPackage &&
                  !isProfile &&
                  sessionBookedPrices.tests &&
                  sessionBookedPrices.tests[itemId] !== undefined
                ) {
                  const sessionPrice = sessionBookedPrices.tests[itemId];
                  const currentPrice = currentPricesMap[`test_${itemId}`];
                  if (
                    currentPrice !== undefined &&
                    currentPrice !== sessionPrice
                  ) {
                    shouldOverride = false;
                  }
                }
              }

              // Override price if should override
              if (shouldOverride) {
                // Check if item exists in sessionBookedPrices based on item type
                if (
                  isPackage &&
                  sessionBookedPrices.packages &&
                  sessionBookedPrices.packages[item.id] !== undefined
                ) {
                  newItem.price = sessionBookedPrices.packages[item.id];
                } else if (
                  isProfile &&
                  sessionBookedPrices.profiles &&
                  sessionBookedPrices.profiles[item.id] !== undefined
                ) {
                  newItem.price = sessionBookedPrices.profiles[item.id];
                } else if (
                  !isPackage &&
                  !isProfile &&
                  sessionBookedPrices.tests
                ) {
                  // For grouped measurements, check and override prices for items in total array first
                  if (
                    newItem.total &&
                    Array.isArray(newItem.total) &&
                    newItem.total.length > 0
                  ) {
                    let hasTotalPrices = false;
                    let shouldOverrideTotal = true;

                    // If hasNavigatedBetweenSteps = true, check if any child item was reselected with new price
                    if (hasNavigatedBetweenSteps) {
                      newItem.total.forEach((childItem) => {
                        const childId = childItem.id || childItem.testId;
                        if (childId) {
                          const sessionPrice =
                            sessionBookedPrices.tests[childId];
                          const currentPrice =
                            currentPricesMap[`test_${childId}`];
                          if (
                            currentPrice !== undefined &&
                            sessionPrice !== undefined &&
                            currentPrice !== sessionPrice
                          ) {
                            shouldOverrideTotal = false;
                          }
                        }
                      });
                    }

                    if (shouldOverrideTotal) {
                      newItem.total = newItem.total.map((childItem) => {
                        const childId = childItem.id || childItem.testId;
                        if (
                          childId &&
                          sessionBookedPrices.tests[childId] !== undefined
                        ) {
                          hasTotalPrices = true;
                          return {
                            ...childItem,
                            price: sessionBookedPrices.tests[childId],
                            testPrice: sessionBookedPrices.tests[childId],
                          };
                        }
                        return childItem;
                      });

                      // If we found prices in total array, recalculate grouped measurement price
                      // This takes priority over the grouped measurement's own price in sessionBookedPrices
                      if (hasTotalPrices) {
                        newItem.price = newItem.total.reduce(
                          (sum, childItem) =>
                            sum + (childItem.price || childItem.testPrice || 0),
                          0
                        );
                      } else if (
                        sessionBookedPrices.tests[item.id] !== undefined
                      ) {
                        // Only override grouped measurement price if we didn't recalculate from total array
                        newItem.price = sessionBookedPrices.tests[item.id];
                      }
                    }
                  } else if (sessionBookedPrices.tests[item.id] !== undefined) {
                    // For non-grouped measurements, override price directly
                    newItem.price = sessionBookedPrices.tests[item.id];
                  }
                }
              }
            }
            return newItem;
          });
          return newProject;
        });
      }

      // Filter  isVisible
      const newDataFilter = newData.map((item) => {
        const newItem = cloneDeep(item);

        return {
          ...newItem,
          items: newItem.items.filter((it) => it.isVisible !== false),
        };
      });
      setData(newDataFilter);
      setLocalData(newDataFilter);
      setLoadingSearch(false);
    });
  }, [category, isProfile, isPackage, locationId]);

  useEffect(() => {
    if (data.length === 0) return;
    setLoadingSearch(true);
    let newData = [];
    data.forEach((project) => {
      const results = [];
      const { items } = project;
      items.forEach((item) => {
        const { name = '', code = '' } = item;
        if (
          name?.toLowerCase().includes(debounceSearch.toLowerCase()) ||
          code?.toLowerCase().includes(debounceSearch.toLowerCase())
        ) {
          results.push(item);
        }
      });

      newData.push({ ...project, items: results });
    });
    setTimeout(() => {
      setLocalData(newData);
      setLoadingSearch(false);
    }, 250);
  }, [debounceSearch]);

  // Checked Table data if data exist
  const updateCheckedData = (dataUpdated = [], testExists = []) => {
    const newDataLocal = [...dataUpdated];

    testExists.forEach((test) => {
      const indexProject = findIndex(
        dataUpdated,
        (it) => it.id === test.projectId
      );
      if (indexProject < 0) return;
      const updatedProject = newDataLocal[indexProject];
      const indexTestChange = findIndex(
        updatedProject.items,
        (it) => it.keyCompare === test.keyCompare
      );

      if (indexTestChange < 0) return;
      updatedProject.items[indexTestChange] = {
        ...test,
        hasOptional: updatedProject?.items[indexTestChange]?.hasOptional,
      };
    });

    return newDataLocal;
  };

  const updateCheckedPackageData = (
    dataUpdated = [],
    testExists = [],
    projectId
  ) => {
    let newDataLocal = [...dataUpdated];
    let newData = [];
    let packageItems = [];

    newDataLocal = newDataLocal.map((item) => ({
      ...item,
      items: item.items.map((test) => ({ ...test, isChecked: false })),
    }));

    newDataLocal
      .filter((it) => projectId === it.id)
      .map((item) => (packageItems = item.items));

    newData = packageItems.map((item) =>
      item.id === testExists.id ? testExists : { ...item, isChecked: false }
    );
    newData.forEach((test) => {
      const indexProject = findIndex(
        dataUpdated,
        (it) => it.id === test.projectId
      );
      if (indexProject < 0) return;
      const updatedProject = newDataLocal[indexProject];
      const indexTestChange = findIndex(
        updatedProject.items,
        (it) => it.keyCompare === test.keyCompare
      );

      if (indexTestChange < 0) return;
      updatedProject.items[indexTestChange] = { ...test };
    });

    return newDataLocal;
  };

  const onChangeDataSelected = (dataItem) => {
    // When selecting an item that was previously unselected, check if price changed
    // and set isUseNewPrice flag if price differs from original
    let newDataItem = { ...dataItem };
    if (
      newDataItem.isChecked &&
      originalPrices &&
      Object.keys(originalPrices).length > 0
    ) {
      let originalPrice = null;
      const itemId = newDataItem.id || newDataItem.testId;

      if (isPackage && originalPrices.packages) {
        originalPrice = originalPrices.packages[itemId];
      } else if (isProfile && originalPrices.profiles) {
        originalPrice = originalPrices.profiles[itemId];
      } else if (!isPackage && !isProfile && originalPrices.tests) {
        // For grouped measurements, compare with sum of original prices from total array
        if (
          newDataItem.total &&
          Array.isArray(newDataItem.total) &&
          newDataItem.total.length > 0
        ) {
          let hasOriginalPrices = false;
          const sumOriginalPrices = newDataItem.total.reduce((sum, item) => {
            const itemOriginalPrice =
              originalPrices.tests?.[item.id || item.testId];
            if (itemOriginalPrice !== undefined && itemOriginalPrice !== null) {
              hasOriginalPrices = true;
              return sum + itemOriginalPrice;
            }
            return sum;
          }, 0);

          if (hasOriginalPrices && newDataItem.price !== sumOriginalPrices) {
            newDataItem.isUseNewPrice = true;
          }
        } else {
          originalPrice = originalPrices.tests[itemId];
        }
      }

      // If original price exists and differs from current price, mark as using new price
      if (
        originalPrice !== null &&
        originalPrice !== undefined &&
        originalPrice !== newDataItem.price
      ) {
        newDataItem.isUseNewPrice = true;
      }
    }

    if (isPackage) {
      const dataUpdated = updateCheckedPackageData(
        data,
        newDataItem,
        newDataItem.projectId
      );
      const dataLocalUpdated = updateCheckedPackageData(
        localData,
        newDataItem,
        newDataItem.projectId
      );

      setLocalData(dataLocalUpdated);
      setData(dataUpdated);
      handleChangeData(dataUpdated, filterKey);
    } else {
      const dataUpdated = updateCheckedData(data, [newDataItem]);
      const dataLocalUpdated = updateCheckedData(localData, [newDataItem]);

      setLocalData(dataLocalUpdated);
      setData(dataUpdated);
      handleChangeData(dataUpdated, filterKey);
    }
  };

  return (
    <Box py={2} px={2.5} width="100%">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSearchInput
            fullWidth
            variant="outlined"
            placeholder="Search by name"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            InputProps={{
              endAdornment: (
                <>
                  <InputAdornment position="end">
                    <IconButton
                      style={{
                        visibility: !isEmpty(searchKey) ? 'visible' : 'hidden',
                      }}
                      onClick={() => setSearchKey('')}
                    >
                      <CloseCircle
                        height={20}
                        width={20}
                        style={{
                          color: '#666666',
                        }}
                      />
                    </IconButton>
                  </InputAdornment>
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                </>
              ),
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ height: 'calc(100vh - 330px)', overflowY: 'auto' }}
        >
          {loadingSearch && (
            <div className={classes.loadingWrapper}>
              <CircularProgress color="primary" />
            </div>
          )}
          {!loadingSearch &&
            localData.map((testItem) => (
              <CustomCheckboxRowItem
                isProfile={isProfile}
                isPackage={isPackage}
                id={testItem.id}
                key={testItem.id}
                title={testItem.name}
                data={testItem.items}
                projectId={projectId}
                onChangeDataSelected={onChangeDataSelected}
                formValue={formValue}
                setFormValue={setFormValue}
                packageDetail={packageDetail}
                setPackageDetail={setPackageDetail}
                currentPackage={currentPackage}
                setCurrentPackage={setCurrentPackage}
                dataPackageExisted={dataPackageExisted}
                restrictedTestIds={restrictedTestIds}
                locationId={locationId}
              />
            ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ServicesItem;
